module.exports = __webpack_public_path__ + "static/media/25-web-or-mls-DSC06642.5a3d2387.jpg";